import React, { FC, useMemo, useState } from 'react';

import { Stack, Typography, useDesktop, useMediaSwitch } from 'Modules/ui3';

import { ContainerBox } from '../ContainerBox';
import { EmissionssTable, EmissionsTableProps } from '../EmissionsTable';
import { PagingControls } from '../PagingControls';
import { emissionsColumns } from '../../columns';


const ROW_COUNT = 10;
type EmissionsProps = Omit<EmissionsTableProps, 'columns'>;

export const Emissions: FC<EmissionsProps> = ({ data, ...props }) => {
    const isDesktop = useDesktop();
    const [currentPage, setCurrentPage] = useState(1);
    const pageCount = useMemo(() => Math.ceil(data.length / ROW_COUNT), [data.length]);
    const displayedData = useMemo(() =>
        data.slice((currentPage - 1) * ROW_COUNT, currentPage * ROW_COUNT),
    [currentPage, data]);
    return (
        <ContainerBox>
            <Typography
                fontSize={isDesktop ? '31px' : '22px'}
                fontWeight='500'
                lineHeight={isDesktop ? '1.3' : '1.25'}
                color='grayscale.shade95'
                mb={useMediaSwitch(8, 6, 5)}
            >
                Выпуски
            </Typography>
            <Stack spacing={isDesktop ? 8 : 6} alignItems='center'>
                <EmissionssTable data={displayedData} columns={emissionsColumns} {...props} />
                <PagingControls
                    currentPage={currentPage}
                    onChange={setCurrentPage}
                    pageCount={pageCount}
                    showNumbers
                />
            </Stack>
        </ContainerBox>
    );
};
